import { Select } from "antd"
import styled from "styled-components"

export const DatasetSelect = styled(Select)`
    width: 100%;
    margin-bottom: 10px;
`
